import { CartEvent, CART_BASE_FEATURE, ORDER_ENTRIES_CONTEXT } from '@spartacus/cart/base/root';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, NgModule } from '@angular/core';
import { facadeFactory, provideDefaultConfigFactory, provideDefaultConfig, AuthGuard } from '@spartacus/core';
import { LAUNCH_CALLER, CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Base saved cart event. Most cart events should have these properties.
 */
class SavedCartEvent extends CartEvent {}
// =====================================================================
let SaveCartEvent = /*#__PURE__*/(() => {
  class SaveCartEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'SaveCartEvent';
    }
  }
  return SaveCartEvent;
})();
let SaveCartSuccessEvent = /*#__PURE__*/(() => {
  class SaveCartSuccessEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'SaveCartSuccessEvent';
    }
  }
  return SaveCartSuccessEvent;
})();
let SaveCartFailEvent = /*#__PURE__*/(() => {
  class SaveCartFailEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'SaveCartEvent';
    }
  }
  return SaveCartFailEvent;
})();
let RestoreSavedCartEvent = /*#__PURE__*/(() => {
  class RestoreSavedCartEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'RestoreSavedCartEvent';
    }
  }
  return RestoreSavedCartEvent;
})();
let RestoreSavedCartSuccessEvent = /*#__PURE__*/(() => {
  class RestoreSavedCartSuccessEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'RestoreSavedCartSuccessEvent';
    }
  }
  return RestoreSavedCartSuccessEvent;
})();
let RestoreSavedCartFailEvent = /*#__PURE__*/(() => {
  class RestoreSavedCartFailEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'RestoreSavedCartFailEvent';
    }
  }
  return RestoreSavedCartFailEvent;
})();
let EditSavedCartEvent = /*#__PURE__*/(() => {
  class EditSavedCartEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'EditSavedCartEvent';
    }
  }
  return EditSavedCartEvent;
})();
let EditSavedCartSuccessEvent = /*#__PURE__*/(() => {
  class EditSavedCartSuccessEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'EditSavedCartSuccessEvent';
    }
  }
  return EditSavedCartSuccessEvent;
})();
let EditSavedCartFailEvent = /*#__PURE__*/(() => {
  class EditSavedCartFailEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'EditSavedCartFailEvent';
    }
  }
  return EditSavedCartFailEvent;
})();
let CloneSavedCartEvent = /*#__PURE__*/(() => {
  class CloneSavedCartEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'CloneSavedCartEvent';
    }
  }
  return CloneSavedCartEvent;
})();
let CloneSavedCartSuccessEvent = /*#__PURE__*/(() => {
  class CloneSavedCartSuccessEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'CloneSavedCartSuccessEvent';
    }
  }
  return CloneSavedCartSuccessEvent;
})();
let CloneSavedCartFailEvent = /*#__PURE__*/(() => {
  class CloneSavedCartFailEvent extends SavedCartEvent {
    /**
     * Event's type
     */
    static {
      this.type = 'CloneSavedCartFailEvent';
    }
  }
  return CloneSavedCartFailEvent;
})();
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CART_SAVED_CART_FEATURE = 'cartSavedCart';
const CART_SAVED_CART_CORE_FEATURE = 'cartSavedCartCore';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let SavedCartFacade = /*#__PURE__*/(() => {
  class SavedCartFacade {
    static {
      this.ɵfac = function SavedCartFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SavedCartFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SavedCartFacade,
        factory: () => (() => facadeFactory({
          facade: SavedCartFacade,
          feature: CART_SAVED_CART_CORE_FEATURE,
          methods: ['editSavedCart', 'deleteSavedCart', 'getSavedCart', 'getSavedCartList', 'loadSavedCart', 'clearCloneSavedCart', 'clearRestoreSavedCart', 'clearSaveCart', 'clearSavedCarts', 'get', 'getList', 'getCloneSavedCartProcessError', 'getCloneSavedCartProcessLoading', 'getCloneSavedCartProcessSuccess', 'getRestoreSavedCartProcessError', 'getRestoreSavedCartProcessLoading', 'getRestoreSavedCartProcessSuccess', 'getSaveCartProcessError', 'getSaveCartProcessLoading', 'getSaveCartProcessSuccess', 'getSavedCartListProcess', 'getSavedCartListProcessLoading', 'isStable', 'cloneSavedCart', 'loadSavedCarts', 'restoreSavedCart', 'saveCart'],
          async: true
        }))(),
        providedIn: 'root'
      });
    }
  }
  return SavedCartFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
LAUNCH_CALLER['SAVED_CART'] = 'SAVED_CART';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SavedCartFormType = /*#__PURE__*/function (SavedCartFormType) {
  SavedCartFormType["EDIT"] = "edit";
  SavedCartFormType["DELETE"] = "delete";
  SavedCartFormType["SAVE"] = "save";
  SavedCartFormType["RESTORE"] = "restore";
  return SavedCartFormType;
}(SavedCartFormType || {});
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const SavedCartOrderEntriesContextToken = new InjectionToken('SavedCartOrderEntriesContext');
const NewSavedCartOrderEntriesContextToken = new InjectionToken('NewSavedCartOrderEntriesContext');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// TODO: Inline this factory when we start releasing Ivy compiled libraries
function defaultCartSavedCartComponentsConfig() {
  const config = {
    featureModules: {
      [CART_SAVED_CART_FEATURE]: {
        cmsComponents: ['AddToSavedCartsComponent', 'AccountSavedCartHistoryComponent', 'SavedCartDetailsOverviewComponent', 'SavedCartDetailsItemsComponent', 'SavedCartDetailsActionComponent'],
        dependencies: [CART_BASE_FEATURE]
      },
      // by default core is bundled together with components
      [CART_SAVED_CART_CORE_FEATURE]: CART_SAVED_CART_FEATURE
    }
  };
  return config;
}
let SavedCartRootModule = /*#__PURE__*/(() => {
  class SavedCartRootModule {
    static {
      this.ɵfac = function SavedCartRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SavedCartRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SavedCartRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultCartSavedCartComponentsConfig), provideDefaultConfig({
          routing: {
            routes: {
              savedCarts: {
                paths: ['my-account/saved-carts']
              },
              savedCartsDetails: {
                paths: ['my-account/saved-cart/:savedCartId'],
                paramsMapping: {
                  savedCartId: 'savedCartId'
                }
              }
            }
          }
        })],
        imports: [RouterModule.forChild([{
          // @ts-ignore
          path: null,
          canActivate: [AuthGuard, CmsPageGuard],
          component: PageLayoutComponent,
          data: {
            cxRoute: 'savedCartsDetails',
            cxContext: {
              [ORDER_ENTRIES_CONTEXT]: SavedCartOrderEntriesContextToken
            }
          }
        }, {
          // @ts-ignore
          path: null,
          canActivate: [AuthGuard, CmsPageGuard],
          component: PageLayoutComponent,
          data: {
            cxRoute: 'savedCarts',
            cxContext: {
              [ORDER_ENTRIES_CONTEXT]: NewSavedCartOrderEntriesContextToken
            }
          }
        }])]
      });
    }
  }
  return SavedCartRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CART_SAVED_CART_CORE_FEATURE, CART_SAVED_CART_FEATURE, CloneSavedCartEvent, CloneSavedCartFailEvent, CloneSavedCartSuccessEvent, EditSavedCartEvent, EditSavedCartFailEvent, EditSavedCartSuccessEvent, NewSavedCartOrderEntriesContextToken, RestoreSavedCartEvent, RestoreSavedCartFailEvent, RestoreSavedCartSuccessEvent, SaveCartEvent, SaveCartFailEvent, SaveCartSuccessEvent, SavedCartEvent, SavedCartFacade, SavedCartFormType, SavedCartOrderEntriesContextToken, SavedCartRootModule, defaultCartSavedCartComponentsConfig };
